// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-container[data-v-32fade3e] {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.9);\n  color: #5E00B5;\n}\n.loading-container .loading-icon[data-v-32fade3e] {\n  -webkit-animation: ani-load-loop 1s linear infinite;\n          animation: ani-load-loop 1s linear infinite;\n}\n", ""]);
// Exports
module.exports = exports;
